import MainStyles from 'assets/styles/main.module.css';
import { useSelector } from 'react-redux';
import {
  selectUserEmail,
  selectUserAuthMethod,
} from 'modules/loggedUserInfo/selectors';
import { MY_INFORMATION_PAGE_TRANSLATIONS } from 'const/translations';
import clsx from 'clsx';
import flowersImage from 'assets/images/loginNewBg.svg';
import { Section } from 'components/Section';
import { selectUserCurrentCompany } from 'modules/loggedUserInfo/selectors';
import { CompanyContact } from 'components/Contacts';
import { InformationRow } from 'components/InformationRow';
import QRCodeComponent from 'components/QRCode';
import Styles from './MyInformation.module.css';

const informationLinks = {
  CHANGE_EMAIL:
    'https://aide.myexco.net/help/fr-fr/2-questions-frequemment-posees/46-modifiez-votre-adresse-e-mail-de-connexion-a-my-exco',
  CHANGE_PASSWORD:
    'https://aide.myexco.net/help/fr-fr/2-questions-frequemment-posees/2-modifiez-votre-mot-de-passe',
  SSO: 'https://key.myexco.fr/realms/myexco/account',
};

export const MyInformation = () => {
  const currentEmail = useSelector(selectUserEmail);
  const authMethod = useSelector(selectUserAuthMethod);
  const currentCompany = useSelector(selectUserCurrentCompany);

  const siret = currentCompany?.siret;
  const siren = siret?.substring(0, 9);

  const isSiretCorrect = siret?.length >= 14;

  const qrCodeUrl = `https://data.inpi.fr/export/companies?format=pdf&ids=["${siren}"]&est=all `;

  const isAuthMethodSSO = authMethod?.toLowerCase() === 'sso';

  return (
    <div className={Styles.hubPageBackground}>
      <div className={clsx(MainStyles.container)}>
        <img className={Styles.flowersImg} src={flowersImage} alt="flowers" />
        <Section
          title={MY_INFORMATION_PAGE_TRANSLATIONS.TITLE}
          titleTextColor="white"
        >
          <div className={Styles.container}>
            <CompanyContact
              label={MY_INFORMATION_PAGE_TRANSLATIONS.EMAIL_MY_CURRENT_LOGIN}
              emails={currentEmail.toLowerCase()}
              hideIcon
            />
            <InformationRow
              label={MY_INFORMATION_PAGE_TRANSLATIONS.CHANGE_EMAIL}
              href={informationLinks.CHANGE_EMAIL}
            />
            <InformationRow
              label={MY_INFORMATION_PAGE_TRANSLATIONS.CHANGE_PASSWORD}
              href={informationLinks.CHANGE_PASSWORD}
            />

            {isAuthMethodSSO && (
              <InformationRow
                label={MY_INFORMATION_PAGE_TRANSLATIONS.SSO}
                href={informationLinks.SSO}
                labelIsLink
                style={{ marginBottom: '30px' }}
              />
            )}

            <QRCodeComponent
              url={qrCodeUrl}
              siren={siren}
              isSiretCorrect={isSiretCorrect}
            />
          </div>
        </Section>
      </div>
    </div>
  );
};
